import React, {Fragment} from "react";
import {Button, Col, Container, FormGroup, Media, Row} from "reactstrap";
import localized from "../../i18n";
import {Link} from "react-router-dom";
import {Formik} from "formik";
import Field from "../Field";
import {emailvalidate} from "../Field/validate";
import axios from "axios";
import {handleError, showsuccesToast} from "../HandleError";
import {useNavigate} from "react-router-dom";

const ForgetPassword = () => {
    const navigate = useNavigate();
    const resetPassword = (values, setSubmitting) => {
        setSubmitting(true);
        axios.post("/api/forget-password", values)
            .then((response) => {
                setSubmitting(false);
                showsuccesToast(localized.forgotten_password_sent_title);
                navigate('/')
            }).catch((err) => {
            handleError(err);
            setSubmitting(false);
        })
    }

    return (
        <Container fluid={true} className="p-0">
            <Row className="m-0">
                <Col xs="12" className="p-0">
                    <div className="login-card auth-login">
                        <div>
                            <div className="logo">
                                <Media
                                    className={"img-fluid for-light w-50"}
                                    src={`${require("../../assets/images/logo/logo.png")}`}
                                    alt={"logo image"}
                                />
                            </div>
                            <div className="login-main login-tab">
                                <Formik
                                    initialValues={{
                                        email: "",
                                    }}
                                    onSubmit={(values, {setSubmitting}) => resetPassword(values, setSubmitting)}
                                >
                                    {props => {
                                        const {handleSubmit, isSubmitting} = props;
                                        return (
                                            <form onSubmit={handleSubmit} className="theme-form">
                                                <Fragment>
                                                    <h2 className={"text-center"}> {localized.forgotten_password_title} </h2>
                                                    <p className={"text-center"}>
                                                        {localized.forgotten_password_description}
                                                    </p>
                                                </Fragment>
                                                <Field
                                                    placeholder={localized.EmailAddress}
                                                    name="email"
                                                    type="email"
                                                    validate={emailvalidate}
                                                />
                                                <div className="text-end mt-3">
                                                    <Button
                                                        type="submit"
                                                        color={"primary w-100"}
                                                        className={"btn-block"}
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? "Sending..." : localized.sent_link}
                                                    </Button>
                                                </div>
                                            </form>
                                        )
                                    }}
                                </Formik>
                                <p className="mt-4 mb-0 text-center">
                                    Don't have account?
                                    <Link
                                        className="ms-2"
                                        to={`/signup`}
                                    >
                                        {localized.CreateAccount}
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
export default ForgetPassword;